// action types
import ApiService from "../../api.service";
import {SET_ERROR} from "../auth.module";

export const CONTRACT_ONLINE_CREATE = "contract-online/store";
export const CONTRACT_ONLINE_UPDATE = "contract-online/update";
export const CONTRACT_FIND_BY_CUSTOMER = "contract-online/by-customer-id";
export const CONTRACT_ONLINE_GET_TUITION = "contract-online/get-all-tuition";
export const CONTRACT_ONLINE_SEND_LINK_SMS = "contract-online/send-link-confirm-sms";
export const CONTRACT_ONLINE_SEND_OTP_BY_PHONE = "contract-online/send-otp-by-phone";
export const CONTRACT_ONLINE_VERIFY_PHONE_PHONE = "contract-online/verify-phone";
export const CONTRACT_ONLINE_LIST_BY_TVV = "contract-online/contracts";
export const CONTRACT_ONLINE_GET_BY_ID = "contract-online/get-by-id";
export const CONTRACT_ONLINE_GET_SHORT_LINK = "contract-online/get-short-link";
export const GET_POLICY = "contract-online/get-policy";
export const GET_RATIO_PAYMENT = "contract-online/ratio-payment";
export const CHANGE_DESTINATION = "contract-online/change-destination";
export const GET_PAYMENT_OPTION_BY_CONTRACT_ID = "payment-option/get-by-contract-id";
export const UPDATE_PAYMENT_OPTION_BY_CONTRACT = "payment-option/update-by-contract-id";
export const GET_CONTRACT_BY_SALE = "contract-online/get-contract-by-sale";
export const UPDATE_INPUT_DEBT_CONTRACT = "contract-online/update-input-debt-contract";
export const GET_IMPORTANT_WORK = "important-work/get-important-work";
export const UPDATE_IMPORTANT_WORK = "important-work/update-important-work";
export const CREATE_ADDITIONAL_IMPORTANT_WORK = "important-work/create-additional-important-work";
export const PRESIGNED_UPLOAD_URL = "citime/presigned-upload-url";
export const SCAN_ID_CARD = "citime/idcard/scan";
export const SCAN_ID_CARD_BACK = "citime/idcard/scan/back";
export const CONTRACT_ONLINE_CREATE_V2 = "contract-online/create-v2";
export const CONTRACT_ONLINE_UPDATE_V2 = "contract-online/update-v2";
export const PAYMENT_TIME_OF_COMBO = "citime/option-installment-months";
export const PREPAYMENT_OF_COMBO = "citime/option-prepayment-percents";
export const CONTRACT_ONLINE_V2_GET_BY_ID = "contract-online/get-by-id-v2"; 
export const CONTRACT_CITIME_UPDATE_NEW_VERSION = "contract-online/citime/update-new-version";
export const CONTRACT_CITIME_NEW_VERSION_SEND_ZNS = 'v2/contract-registrations/resend-link'
// mutation types

// state types
const state = {
    payment: []
};

const getters = {};

const actions = {
    /**
     * Get tuition payments
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CONTRACT_ONLINE_GET_TUITION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${CONTRACT_ONLINE_GET_TUITION}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Get contracts
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CONTRACT_ONLINE_LIST_BY_TVV](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${CONTRACT_ONLINE_LIST_BY_TVV}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [GET_CONTRACT_BY_SALE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${GET_CONTRACT_BY_SALE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Get contract by id
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CONTRACT_ONLINE_GET_BY_ID](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/${CONTRACT_ONLINE_GET_BY_ID}`, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_IMPORTANT_WORK](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${GET_IMPORTANT_WORK}`, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [UPDATE_IMPORTANT_WORK](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${UPDATE_IMPORTANT_WORK}`, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Create contract online
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CONTRACT_ONLINE_CREATE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CONTRACT_ONLINE_CREATE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Update contract online
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CONTRACT_ONLINE_UPDATE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CONTRACT_ONLINE_UPDATE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Send link sms
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CONTRACT_ONLINE_SEND_LINK_SMS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CONTRACT_ONLINE_SEND_LINK_SMS}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Send otp
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CONTRACT_ONLINE_SEND_OTP_BY_PHONE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CONTRACT_ONLINE_SEND_OTP_BY_PHONE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Verify phone
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CONTRACT_ONLINE_VERIFY_PHONE_PHONE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CONTRACT_ONLINE_VERIFY_PHONE_PHONE}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Get contract by customer id
     * @param context
     * @param id
     * @returns {Promise}
     */
    [CONTRACT_FIND_BY_CUSTOMER](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/${CONTRACT_FIND_BY_CUSTOMER}`, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    /**
     * Get short link
     * @param context
     * @param payload
     * @returns {Promise}
     */
    [CONTRACT_ONLINE_GET_SHORT_LINK](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${CONTRACT_ONLINE_GET_SHORT_LINK}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [GET_POLICY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_POLICY, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [GET_RATIO_PAYMENT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_RATIO_PAYMENT, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [CHANGE_DESTINATION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(CHANGE_DESTINATION, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [GET_PAYMENT_OPTION_BY_CONTRACT_ID](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_PAYMENT_OPTION_BY_CONTRACT_ID, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [UPDATE_PAYMENT_OPTION_BY_CONTRACT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/${UPDATE_PAYMENT_OPTION_BY_CONTRACT}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [UPDATE_INPUT_DEBT_CONTRACT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(UPDATE_INPUT_DEBT_CONTRACT, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },

    [CREATE_ADDITIONAL_IMPORTANT_WORK](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(CREATE_ADDITIONAL_IMPORTANT_WORK, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [PRESIGNED_UPLOAD_URL](context, payload) {
        return ApiService.post("citime/presigned-upload-url", payload)
            .then(({ data }) => {
                return data;
            });
    },
    [SCAN_ID_CARD](context, payload) {
    return ApiService.post("citime/idcard/scan", payload, { timeout: 30000 })
        .then(({ data }) => {
            return data;
        });
    },
    [CONTRACT_ONLINE_CREATE_V2](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/v2/contract-registrations`, payload) 
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [CONTRACT_ONLINE_UPDATE_V2](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/v2/contract-registrations/${payload.id}`, payload) 
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [PAYMENT_TIME_OF_COMBO](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${PAYMENT_TIME_OF_COMBO}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [PREPAYMENT_OF_COMBO](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/${PREPAYMENT_OF_COMBO}`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [SCAN_ID_CARD_BACK](context, payload) {
        return ApiService.post("citime/idcard/scan/back", payload, { timeout: 30000 })
            .then(({ data }) => {
                return data;
            });
    },
    [CONTRACT_ONLINE_V2_GET_BY_ID](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/v2/contract-registrations`, id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [CONTRACT_CITIME_UPDATE_NEW_VERSION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/v2/contract-registrations/${payload.id}/citime-profile`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [CONTRACT_CITIME_NEW_VERSION_SEND_ZNS](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/v2/contract-registrations/${id}/resend-link`)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
